import Effect from '@/roc/effects/Effect';
import EffectMechanic from '@/roc/effects/EffectMechanic';
import ProductionOutputType from "@/roc/effects/Production/ProductionOutputType";
class AbstractProduction extends Effect {
    __duration;
    __output;
    constructor(mechanic, duration, output) {
        super(mechanic);
        this.__duration = duration;
        this.__output = output;
    }
    get output() {
        return this.__output;
    }
    producesGoods() {
        return ProductionOutputType.CURRENT_ERA_PRIMARY_GOODS === this.output.output
            || ProductionOutputType.CURRENT_ERA_SECONDARY_GOODS === this.output.output
            || ProductionOutputType.CURRENT_ERA_TERTIARY_GOODS === this.output.output
            || ProductionOutputType.ALL_CURRENT_ERA_GOODS === this.output.output
            || ProductionOutputType.ALL_PREVIOUS_ERA_GOODS === this.output.output
            || ProductionOutputType.PREVIOUS_ERA_PRIMARY_GOODS === this.output.output
            || ProductionOutputType.PREVIOUS_ERA_SECONDARY_GOODS === this.output.output
            || ProductionOutputType.PREVIOUS_ERA_TERTIARY_GOODS === this.output.output;
    }
    producesFood() {
        return ProductionOutputType.FOOD === this.output.output;
    }
    producesGold() {
        return ProductionOutputType.GOLD === this.output.output;
    }
    formatDescription(level, era) {
        let am = this.__output.calculate(level, era);
        if (!am) {
            return null;
        }
        am = this.applyMods(am);
        let desc;
        if (this.__output.isChest()) {
            if (this.__output.items) {
                const items = [];
                for (let i = 0; i < this.__output.items.length; i++) {
                    const item = this.__output.items[i];
                    const am2 = item.calculate(level, era);
                    if (!am2) {
                        continue;
                    }
                    items.push(item.format(am2));
                }
                desc = items.join('<br>');
            }
        }
        else {
            desc = this.__output.format(am);
        }
        const result = [];
        if (!this.__output.description) {
            result.push('Produce');
            if (this.__mechanic === EffectMechanic.PRODUCTION_QUEUE) {
                result[0] += 's';
            }
            if (this.__output.isChest() && this.__output.items) {
                result.push('chest with one of:<br>');
            }
        }
        else if (this.__output.description.endsWith('.')) {
            desc = this.__output.description.slice(0, -1);
        }
        else {
            desc = this.__output.description;
        }
        result.push(desc);
        let dur = this.__duration.format(level, era);
        if (this.__mechanic === EffectMechanic.PASSIVE_PRODUCTION || this.__mechanic === EffectMechanic.TRIGGERED_PRODUCTION) {
            result.push('per');
            if (dur === '1d') {
                dur = 'day';
            }
        }
        else {
            result.push('in');
        }
        result.push(dur);
        return result.join(' ');
    }
}
export default AbstractProduction;
